import { render, staticRenderFns } from "./InstallIOSApp.vue?vue&type=template&id=7972e4e7&scoped=true"
import script from "./InstallIOSApp.vue?vue&type=script&lang=js"
export * from "./InstallIOSApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972e4e7",
  null
  
)

export default component.exports